import { ConfigState as State, ConfigAction as Action } from "./reducer";
export type ConfigState = State;
export type ConfigAction = Action;
export { ReducerActions } from "./reducer";
